import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, Chip, IconButton
} from '@mui/material';
import {
  DriveFileMove as DriveFileMoveIcon, Close as CloseIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import FolderTreeView from './FolderTreeView';

const FolderDialog = ({ 
  open, 
  onClose, 
  formTitle, 
  folderOptions, 
  selectedFolderIds, 
  setSelectedFolderIds 
}) => {
  const { t } = useTranslation();

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        elevation: 24,
        sx: {
          maxHeight: '80vh',
          borderRadius: 2,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ 
        borderBottom: '1px solid #e0e0e0',
        background: 'linear-gradient(to right, #f7f9fc, #edf2f7)',
        py: 2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
      }}>
        <DriveFileMoveIcon color="primary" />
        <Typography variant="h6" component="span">{t('add_form_to_folder')}</Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ 
          p: 2, 
          mb: 3, 
          borderRadius: 1, 
          bgcolor: 'info.light', 
          color: 'info.contrastText' 
        }}>
          <Typography variant="body2">
            "{formTitle}" formunu eklemek istediğiniz klasörleri seçin
          </Typography>
        </Box>
        
        {selectedFolderIds.length > 0 && (
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 1, 
            mb: 3, 
            p: 2,
            borderRadius: 1,
            border: '1px dashed',
            borderColor: 'primary.main',
            bgcolor: 'rgba(25, 118, 210, 0.05)'
          }}>
            <Typography variant="subtitle2" sx={{ width: '100%', mb: 1 }}>
              {t('selected_folders')}
            </Typography>
            {selectedFolderIds.map(value => {
              const folder = folderOptions.find(opt => opt.value === value);
              return folder ? (
                <Chip 
                  key={value} 
                  label={folder.label}
                  deleteIcon={<CloseIcon fontSize="small" />}
                  onDelete={() => {
                    setSelectedFolderIds(prev => prev.filter(id => id !== value));
                  }}
                  sx={{
                    fontWeight: 500,
                    bgcolor: 'background.paper',
                    '&:hover': {
                      bgcolor: 'background.default',
                    },
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }}
                />
              ) : null;
            })}
          </Box>
        )}
        
        <FolderTreeView 
          folderOptions={folderOptions} 
          selectedFolders={selectedFolderIds}
          setSelectedFolders={setSelectedFolderIds}
        />
      </DialogContent>
      <DialogActions sx={{ 
        borderTop: '1px solid #e0e0e0',
        p: 2.5,
        bgcolor: '#f9fafc'
      }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          sx={{ px: 2 }}
        >
          {t('cancel')}
        </Button>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary"
          sx={{ px: 3 }}
        >
          {t('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderDialog;
